import { render } from "./editUnitTest.vue?vue&type=template&id=22aa2218&scoped=true"
import script from "./editUnitTest.js?vue&type=script&lang=js"
export * from "./editUnitTest.js?vue&type=script&lang=js"

import "./editUnitTest.vue?vue&type=style&index=0&id=22aa2218&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22aa2218"]])

export default __exports__